import { render } from "./PaymentBack.vue?vue&type=template&id=13af81a9"
import script from "./PaymentBack.vue?vue&type=script&lang=js"
export * from "./PaymentBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__